export default "__VITE_ASSET__204bf141__"